var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 210,
    viewBox: "0 0 256 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1739_1749)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.549,
    width: 270.209,
    height: 163.119,
    rx: 30,
    transform: "rotate(9.72325 27.549 0)",
    fill: "#942624"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6678,
    y: 17.3931,
    width: 204.962,
    height: 85.8145,
    rx: 20,
    transform: "rotate(9.72325 57.6678 17.3931)",
    fill: "#432818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.612,
    y: 29.7539,
    width: 149.644,
    height: 20.5671,
    rx: 10,
    transform: "rotate(9.72325 83.612 29.7539)",
    fill: "#942624"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.2221,
    y: 61.21,
    width: 149.644,
    height: 37.5882,
    rx: 10,
    transform: "rotate(9.72325 78.2221 61.21)",
    fill: "#942624"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.93,
    cy: 100.276,
    r: 12.4112,
    transform: "rotate(9.72325 194.93 100.276)",
    fill: "#FFF9EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.659,
    cy: 84.4653,
    r: 12.4112,
    transform: "rotate(9.72325 102.659 84.4653)",
    fill: "#FFF9EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.257 132.624L216.608 145.364L234.173 200.9L133.514 183.652L142.257 132.624ZM142.257 132.624L67.9067 119.884L32.8542 166.404L133.513 183.652L142.257 132.624Z",
    fill: "#FFF9EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.8525,
    cy: 135.465,
    r: 6.3829,
    transform: "rotate(9.72325 74.8525 135.465)",
    fill: "#432818"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.3829,
    cy: 6.3829,
    r: 6.3829,
    transform: "matrix(-0.985635 -0.168889 -0.168889 0.985635 211.541 152.411)",
    fill: "#432818"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.6928,
    cy: 157.675,
    r: 6.3829,
    transform: "rotate(9.72325 61.6928 157.675)",
    fill: "#432818"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.3829,
    cy: 6.3829,
    r: 6.3829,
    transform: "matrix(-0.985635 -0.168889 -0.168889 0.985635 216.556 177.735)",
    fill: "#432818"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1739_1749",
    x: 0.630859,
    y: 4.63086,
    width: 292.615,
    height: 205.149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1739_1749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1739_1749",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.a85bef8a60be8f5711ef09c41cad8649.svg";
export { ForwardRef as ReactComponent };